import React,{useState} from 'react'
import CmsNavbar from '../../CmsComponents/CmsNavbar';
import CmsSidebar from '../../CmsComponents/CmsSidebar';

import Reviews from '../../CmsComponents/Reviews';

function ReviewsPage() {
    const [isOpen,setIsOpen]= useState(false);

    function HandleClicked() {
        setIsOpen(!isOpen);
    }

    return (
        <div>
            <CmsNavbar action={HandleClicked} />
            <CmsSidebar isOpen={isOpen} />
            <Reviews isOpen={isOpen} />
        </div>
    )
}

export default ReviewsPage;